module.exports = __webpack_public_path__ + "img/Comic03-2.def5e66e.png";